import { Controller } from "stimulus"

export default class extends Controller {
  // static targets = ["checkbox"];
  //
  clear() {
    sessionStorage.clear()
    console.log('[stimulus] clear session storage Ok')
  };

  connect() {};
}